import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {
  Table,
  Badge,
  Card,
  Tooltip,
  notification,
  Switch,
  Input, Button, Icon, Form, Row, Col, Popconfirm
} from 'antd'
import Request from '../../../request'
import _ from 'lodash'
import styles from './styles.less'
import { connect } from 'react-redux'
import { TableComp, FormUtils } from 'sz-react-utils-lite'
import { ChooseEmailModal, chooseEmailModalFxn, DisplayDate, formItemLayout } from '../../../components/_utils/appUtils'
import { getAllArticle } from '../actions'
import { ArticleFilters } from '../articleView/articlePages'
import { SendTemplateEmail } from '../../email/actions'
import RevisedArticleDrawer from '../drawers/RevisedArticleDrawer'
import ReactHtmlParser from 'react-html-parser'


const publishArr = [
  { value: true, display: 'Publish', _id: 'publish' },
  { value: false, display: 'Un-Publish', _id: 'unpublish' }
]

@Form.create()
class RejectedArticle extends Component {
  state = {
    edit: false,
    journalList: [],
    volumeList: [],
    issueList: [],
    isPublished: null,
    slugJournal: null,
    slugVolume: null,
    slugIssue: null,
    articleId: null,
    filters: {},
    visibleRevisedArticle: false,
    article: {},
    total: ''
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let { dispatch, form: { getFieldValue } } = this.props
      let obj = {
        ...params,
        ...this.state.filters,
        articleStatus: 'Rejection'
      }
      let regExpFilters = []

      let data = await dispatch(getAllArticle({ ...obj, regExFilters: regExpFilters }))
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  reload = () => {
    this.table.current.reload()
  }
  reloadTable = (data) => {
    if (data.fromDate && data.toDate) {
      data['submittedDate'] = {
        $gte: data.fromDate,
        $lte: data.toDate
      }
      delete data['fromDate']
      delete data['toDate']
    }
    this.setState({ filters: data }, () => {
      this.reload()
    })
  }


  deleteArticle = async (data) => {
    let resp = await Request.deleteArticle(data)
    this.reload()
  }

  getJournalList = async () => {
    let { data } = await Request.journalName()
    let journalList = []
    _.each(data, (item) => {
      journalList.push({
        _id: item.slugJournal,
        value: item.slugJournal,
        display: item.name
      })
    })
    this.setState({
      journalList,
      volumeList: [],
      issueList: []
    })

  }

  getVolumeList = async (data) => {
    let obj = {
      slugJournal: data
    }
    let resp = await Request.journalVolume(obj)
    let volumeList = []
    _.each(resp, (item) => {
      volumeList.push({
        _id: item.slugVolume,
        value: item.slugVolume,
        display: item.name
      })
    })
    this.setState({
      volumeList,
      issueList: []
    })
  }

  getIssueList = async (data) => {
    let obj = {
      slugJournal: this.props.form.getFieldValue('slugJournal'),
      slugVolume: data
    }
    let resp = await Request.journalIssue(obj)
    let issueList = []
    _.each(resp, (item) => {
      issueList.push({
        _id: item.slugIssue,
        value: item.slugIssue,
        display: item.name
      })
    })
    this.setState({
      issueList
    })
  }


  componentDidMount() {
    this.getJournalList()
  }

  sendMailFxn = (record) => {
    let { dispatch } = this.props
    chooseEmailModalFxn({
      callback: async (email) => {
        let obj = {
          articleId: record._id,
          fromEmail: email,
          emailType: 'acknowledgement',
          template: record.processingCharges > 0 ? 'acknowledgementWithCharges' : 'acknowledgementWithoutCharges',
          type: 'article'
        }
        let resp = await dispatch(SendTemplateEmail({
          email,
          id: record._id,
          obj,
          template: obj.template
        }))
        if (resp && resp.success) {
          notification.success({
            message: resp.message
          })
          this.reload()
        }

      }
    })
  }

  render() {

    const { dispatch, form: { getFieldDecorator, getFieldValue, setFieldsValue }, loading } = this.props
    const { journalList, volumeList, issueList } = this.state

    const formProps = {
      getFieldDecorator, getFieldValue, loading
    }


    const columns = [
      {
        key: 'actions',
        title: 'Article Id',
        width: '85px',
        render: (val, record) => (
          <Tooltip title='Edit Details'>
            <a href={`/articleView/${record._id}`}>
              {record.articleNo}
            </a>
            {/*<a*/}
            {/*  onClick={() => {*/}
            {/*    dispatch(getPushPathWrapper('articleView', { id: record._id }))*/}
            {/*  }}>*/}
            {/*  {record.articleNo}*/}
            {/*</a>*/}
          </Tooltip>

        )
      },
      {
        title: 'Submitted Date',
        key: 'submittedDate',
        width: 100,
        dataIndex: 'submittedDate',
        render: (item) => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'ManuScript Title',
        key: 'manuScriptTitle',
        // dataIndex: 'menuScriptTitle'
        render: (item) => {
          return item ? ReactHtmlParser(item) : null
        }
      },
      {
        title: 'Comments Received',
        key: 'underReviewDetails.receiveDate',
        width: 100,
        dataIndex: 'underReviewDetails.receiveDate',
        render: (item) => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'Comments Send',
        key: 'underReviewDetails.sendDate',
        width: 100,
        dataIndex: 'underReviewDetails.sendDate',
        render: (item) => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'Rejection ',
        key: 'rejectionDate',
        width: 100,
        dataIndex: 'rejectionDate',
        render: (item) => {
          return item ? DisplayDate(item) : null
        }
      },

      {
        title: 'Action',
        key: 'Action',
        render: (item, record) => {
          return (
            <>
              <Button className={'roundSmallBtn'}
                      onClick={() => this.setState({ visibleRevisedArticle: true, article: record })}>
                Revised Article</Button>
              {/*<RevisedArticleDrawer Id={record._id} callback={this.reload}>*/}
              {/*</RevisedArticleDrawer>*/}
            </>
          )
        }
      }


    ]

    const fil =
      {
        labelCol: {
          xs: {
            span: 24
          }
          ,
          sm: {
            span: 24
          }
          ,
          md: {
            span: 24
          }
        }
        ,
        wrapperCol: {
          xs: {
            span: 24
          }
          ,
          sm: {
            span: 24
          }
          ,
          md: {
            span: 24
          }
        }
      }

    return (
      <PageHeaderWrapper
        title={`Rejected Articles (${this.state.total})`}>
        <Card bordered={true}>
          <ArticleFilters callback={(data) => {
            this.reloadTable(data)
          }} />
          <TableComp ref={this.table} columns={columns} apiRequest={this.apiRequest} />
        </Card>
        {this.state.visibleRevisedArticle ? <RevisedArticleDrawer
          visible={this.state.visibleRevisedArticle}
          articleId={this.state.article._id}
          article={this.state.article}
          Id={this.state.article._id}
          callback={this.reload}
          edit={false}
          onClose={() => this.setState({ visibleRevisedArticle: false })}
        /> : null}

      </PageHeaderWrapper>
    )

  }
}


const mapStateToProps = (
  {
    global
  }
) => (
  {
    categories: global.categories
  }
)
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RejectedArticle)
